import {
  MiniAvatar,
  PosterSlot,
  StarRating,
  StatusBadge,
  TypeBadge,
} from "./EntryVisuals";
import {
  avatarColor,
  formatEntryDate,
  getAddedByLabel,
  getExtraText,
} from "../utils/helpers";
import { SHADOW, TOKENS as T } from "../styles/styles";

// Media card from the Figma Tracker/Search screens. Shared by both pages.
export default function EntryCard({ entry, currentUser, onTap }) {
  const addedByLabel = getAddedByLabel(entry, currentUser?.uid);
  const extraText = getExtraText(entry);
  const tags = entry.tags || [];
  const date = formatEntryDate(entry.createdAt);

  return (
    <button type="button" onClick={() => onTap?.(entry)} style={cardStyle}>
      <PosterSlot type={entry.type} width={62} height={90} radius={16} />

      <div style={bodyStyle}>
        <div style={badgeRowStyle}>
          <TypeBadge type={entry.type} />
          <StatusBadge entry={entry} />
        </div>

        <h3 style={titleStyle}>{entry.title}</h3>

        <StarRating rating={entry.rating} />

        {(entry.note || extraText) && (
          <p style={noteStyle} className="line-clamp-2">
            {entry.note || extraText}
          </p>
        )}

        <div style={footerStyle}>
          <MiniAvatar
            initial={(addedByLabel[0] || "?").toUpperCase()}
            color={avatarColor(entry.addedBy?.uid || addedByLabel)}
          />
          <span style={footerTextStyle}>{addedByLabel}</span>

          {date && (
            <>
              <span style={dotStyle}>·</span>
              <span style={footerTextStyle}>{date}</span>
            </>
          )}

          {tags[0] && <span style={inlineTagStyle}>#{tags[0]}</span>}
        </div>
      </div>
    </button>
  );
}

const cardStyle = {
  width: "100%",
  textAlign: "left",
  background: T.card,
  borderRadius: 24,
  padding: 16,
  border: "none",
  boxShadow: SHADOW.card,
  display: "flex",
  gap: 14,
  cursor: "pointer",
  transition: "transform 0.15s ease",
  fontFamily: "inherit",
};

const bodyStyle = {
  flex: 1,
  minWidth: 0,
};

const badgeRowStyle = {
  display: "flex",
  alignItems: "center",
  gap: 6,
  flexWrap: "wrap",
  marginBottom: 6,
};

const titleStyle = {
  margin: "0 0 4px",
  fontSize: 15,
  fontWeight: 700,
  lineHeight: 1.35,
  color: T.foreground,
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const noteStyle = {
  margin: "6px 0 0",
  fontSize: 12,
  lineHeight: 1.5,
  color: T.mutedForeground,
};

const footerStyle = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  marginTop: 8,
  flexWrap: "wrap",
};

const footerTextStyle = {
  fontSize: 11,
  color: T.mutedForeground,
};

const dotStyle = {
  color: T.mutedForeground,
  opacity: 0.5,
};

const inlineTagStyle = {
  fontSize: 10,
  padding: "2px 6px",
  borderRadius: 999,
  background: T.muted,
  color: T.mutedForeground,
};
